import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { usePageData } from '../../core'
import { HeaderUserMenu } from './HeaderUserMenu'
import { HeaderCurrentPage } from './HeaderCurrentPage'

const Header = () => {
  const location = useLocation()
  const { currentUser } = useAuth()
  const { pageTitle } = usePageData()

  return (
    <div id='kt_app_header' className='app-header shadow-sm bg-white border-bottom border-gray-300'>
      <div className='app-container container-fluid d-flex align-items-center justify-content-between py-3 px-4'>
        {/* Left side - Current page/menu */}
        <HeaderCurrentPage />
        
        {/* Right side - User account info */}
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export { Header }
